/* eslint-disable semi */
const debug = process.env.NODE_ENV === 'development';

// オブジェクト識別No
let oid = 0;

// グローバルキャッシュ
let globalCache = null;

/**
 * キャッシュ管理
 *
 * キャッシュ格納値として関数が指定された場合は、Promise生成関数とみなします。
 */
export default class Cache {
  constructor () {
    this.oid = oid++;
    this.segments = {};
    this.cache = {};
  }

  normalize (key) {
    return (typeof key === 'string') ? key : JSON.stringify(key);
  }

  get global () {
    if (globalCache == null) {
      globalCache = new Cache();
    }
    return globalCache;
  }

  /**
   * 下層セグメントを取得する
   */
  segment (segment) {
    if (!(segment in this.segments)) {
      this.segments[segment] = new Cache();
    }
    return this.segments[segment];
  }

  /**
   * キャッシュ値を取得する
   * @param {*} key
   * @param {*} value
   */
  get (key, value) {
    key = this.normalize(key);
    if (!(key in this.cache) && (arguments.length > 1)) {
      this.set(key, value);
    }
    return this.cache[key];
  }

  /**
   * キャッシュ値を設定する
   * @param {*} key
   * @param {*} value
   */
  set (key, value) {
    key = this.normalize(key);
    if (typeof value === 'function') {
      this.cache[key] = value().catch(reason => {
        // 例外がスローされた場合はキャッシュから破棄する
        //
        // NOTE
        // 通信キャンセル状態のPromiseがキャッシュ値として残ることは望ましくな
        // いので、通信キャンセルか否かは判定しません。
        this.remove(key);
        throw reason;
      });
    } else {
      this.cache[key] = value;
    }
  }

  exists (key = null) {
    key = this.normalize(key);
    return key in this.cache;
  }

  remove (key = null) {
    // NOTE
    // 破棄時に通信のキャンセル処理が実行されると、キャッシュインスタンスの破棄
    // 後にこの関数が実行される。そのため、判定が必要。
    if (this.cache) {
      key = this.normalize(key);
      delete this.cache[key];
    }
  }

  /**
   * オブジェクトを破棄する
   */
  destroy () {
    if (debug) {
      console.debug(`Cache: ${this.oid} destroy.`);
    }

    // 下層のセグメントも破棄
    Object.keys(this.segments).forEach(segment => {
      this.segments[segment].destroy();
      delete this.segments[segment];
    });

    // cacheを破棄
    Object.keys(this.cache).forEach(key => {
      delete this.cache[key];
    })

    delete this.segments;
    delete this.cache;
  }
};



// WEBPACK FOOTER //
// ./src/core/libs/Cache.js